import { render, staticRenderFns } from "./txtScroll.vue?vue&type=template&id=318a17ac&scoped=true&"
import script from "./txtScroll.vue?vue&type=script&lang=js&"
export * from "./txtScroll.vue?vue&type=script&lang=js&"
import style0 from "./txtScroll.vue?vue&type=style&index=0&id=318a17ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a17ac",
  null
  
)

export default component.exports